/**
 * @module Module
 */
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import { connect, useDispatch } from "react-redux";
import Button from "@material-ui/core/Button";
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import moment from "moment";
import { Text } from "react-internationalization";
import {
  DataValidation,
  ILS_CONSTS,
  NEBRASKA_CONSTS,
  VERDA_CONSTS,
  fetch_NeBraska_Product_Types,
} from "../../Utils/StaticData/Constant";
import { FieldLabel } from "../translations/dynamic";
import AutoComplete1 from "../../Utils/GenericUI/Select";
import { setStateParams } from "../../Redux/Actions/webAppActions";
const CustomButtonSecondary = withStyles({
  root: {
    backgroundColor: "white",
    borderColor: "#0089cf",
    color: "#0089cf",
    size: "small",
    width: "50px",
    height: "35px",
    "&:hover": {
      backgroundColor: "#707070",
      border: " 2px #222831",
      boxShadow: "none",
      color: "white",
      width: "50px",
      height: "35px",
    },
  },
})(Button);

/**
 *Reusable component used by different components for Popup's.
 * @method Modal
 * @param {object} props props that is being passed by the
 * @returns {JSX} returns Modal jsx.
 */
function Modal(props) {
  const [toggle, setToggle] = React.useState("");
  const [isNew, setNew] = React.useState(true);
  // const dispatch = useDispatch();
  // let todayIs = new Date(
  //   `October 01, ${new Date().getFullYear().toString()} 03:24:00`
  // );
  let todayIs = new Date();
  let currentYear = todayIs.getFullYear();
  let nextYear = currentYear + 1;
  let previousYear = currentYear - 1;
  let yearOptions = [
    // { label: "SELECT", value: "" },
    {
      label: currentYear.toString(),
      value: currentYear.toString(),
    },
  ];
  // Check if we are in the period between October and December
  if (todayIs.getMonth() >= 9) { 
    yearOptions.push({
      label: nextYear.toString(),
      value: nextYear.toString(),
    });
  }
  // If it's a new year, remove the last year
  if (todayIs.getMonth() === 0 && todayIs.getDate() === 1) { 
    yearOptions = yearOptions.filter(option => option.value !== previousYear.toString());
  }
  /**
   * Re renders the component everytime and set's toggle.
   * @function useEffect
   * @returns {void}
   */
  React.useEffect(() => {
    setToggle(props.show);
    setTimeout(() => {
      let arr = [];
      Object.keys(props.data).map((key) => {
        if (
          key === "productName" ||
          key === "beneRepSignature" ||
          key === "beneRepSignDate" ||
          key === "beneName" ||
          key === "benePhone" ||
          key === "beneAddress" ||
          key === "initialMethodOfContact" ||
          key === "appointmentDateComp" ||
          key === "agentSign"
        ) {
          arr.push(props.data[key]);
        }
      });
      if (arr.every((x) => x !== "")) {
        var inputs = document.getElementsByTagName("input");
        for (var i = 0; i < inputs.length; i++) {
          inputs[i].disabled = true;
        }
        setNew(false);
      }
    }, 200);
  }, []);

  /**
   * Re renders the component whenever new props are passed.
   * @function useEffect
   * @returns {void}
   */
  React.useEffect(() => {
    if (props.show) {
      setToggle(true);
    }
  }, [props]);
  let customCardArray =
    props.customerId !== NEBRASKA_CONSTS.ID
      ? props.planCardData
      : fetch_NeBraska_Product_Types(props.planCardData);

  // const handleChangeYear = (name) => (event) => {
  //  let value = "";
  //  value = event.target ? event.target.value : event.value;
  // setplanYear(value);
  // this.setState((prevState) => ({
  //   ...prevState,
  //   [name]: value,
  // }));
  //dispatch(setStateParams("year", value));
  // this.props.setStateParams("year", value);
  // };
  return (
    <Dialog open={props.show && toggle} id={props.idName ? props.idName : ""}>
      <DialogTitle class="modalsoacommenttitle">
        {props.addComment ? (
          <h3 class="tab-headingcomment justify-content-between d-flex">
            Add New Comment
            <IconButton
              className="modalsoacommentcloseicon noprint"
              onClick={() => {
                props.modalClosed();
              }}
            >
              <CloseIcon />
            </IconButton>
          </h3>
        ) : (
          <h3 class="tab-headingcomment justify-content-between d-flex">
            <Text id="app.scope" />
            <IconButton
              className="modalsoacommentcloseicon noprint"
              onClick={() => {
                props.modalClosed();
              }}
            >
              <CloseIcon />
            </IconButton>
          </h3>
        )}
      </DialogTitle>
      <DialogContent>
        {props.addComment ? (
          <div class={"modal-body modalsoacommentbodyfont"}>
            <div class="table-container">
              <textarea
                id="add_new_comment"
                class="form-control1 w-100"
                name="addNewComment"
                value={props.data.addNewComment}
                onChange={props.handleChange}
              />
            </div>
          </div>
        ) : (
          <div
            class={
              isNew === false || props?.disable === true
                ? "modal-body modalsoacommentbodyfont disable-form"
                : "modal-body modalsoacommentbodyfont"
            }
          >
            <div class="panel">
              <p>
                <Text id="soa.header1" />
              </p>

              <div class="row mt-2">
                <span class="col-lg-4 col-sm-12 col-md-12">
                  <label for="planYear">
                    <Text id="zipcode.planyear" />
                  </label>
                  <br />
                  <AutoComplete1
                    handleChange={(newVal) =>
                      props.handleDropdown("planYear")(newVal)
                    } //In handleDropdown , currying is used
                    width="236px"
                    //label={<Text id="zipcode.planyear" />}
                    options={yearOptions}
                    defaultValue={yearOptions.find(
                      (data) => data.value === props.data?.planYear
                    )}
                    value={yearOptions.find(
                      (data) => data.value === props.data?.planYear
                    )}
                    name="planYear"
                    id="planYear"
                    //  margin="20px auto"
                  />
                </span>
              </div>
              <br />
              {props.customerId === ILS_CONSTS.ID && (
                <div className="row mb-3">
                  <p className="col-md-12">
                    <strong>
                      <Text id="app.middileInitialheader1" />
                    </strong>
                  </p>
                  <span className="col-md-3">
                    {/* <span class="mt-2 mb-1"> */}
                    <label htmlFor="beneficiaryInitial">
                      <Text id="app.beneficiaryInitial" />
                      <span class="mandatory-field">*</span>
                    </label>
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="text"
                      className={
                        [undefined, null, ""].some(
                          (e3) => e3 === props.data?.beneficiaryInitial
                        )
                          ? "error-input"
                          : "form-control1"
                      }
                      value={props.data?.beneficiaryInitial}
                      id="beneficiaryInitial"
                      name="beneficiaryInitial"
                      onChange={props.handleChange}
                    />
                    {/* </span> */}
                  </span>
                </div>
              )}

              <p>
                <strong>
                  <span class="mandatory-field">*</span>{" "}
                  <Text id="ils.soa.product" />
                </strong>
              </p>
              <fieldset
                class="label-container padding-0"
                for="soa_initial_method_contact"
              >
                {props.planCardData.length > 0
                  ? customCardArray.map((plans, index) => (
                      <label class="soaplans" key={index}>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="checkbox"
                          class="customCheckbox"
                          id={plans.productId}
                          name="productName"
                          value={plans.productId}
                          checked={
                            props.data.productName.includes(plans.productId)
                              ? true
                              : false
                          }
                          onChange={props.handleMutipleCheckbox}
                          disabled={plans?.disable ?? false}
                        />{" "}
                        {props.lang === "en"
                          ? plans.planName
                          : plans?.planNameES}
                      </label>
                    ))
                  : null}
              </fieldset>
              <p>
                <strong>
                  <Text id="soa.para1" />
                  <Text id="soa.para2" />
                </strong>
                <Text id="soa.para3" />
                <Text id="soa.para4" />
                <Text id="soa.para5" />
                <Text id="soa.para6" />
              </p>
              <p>
                <Text id="soa.para7" />
                <strong>
                  <Text id="soa.para8" />
                </strong>
                <Text id="soa.para9" />
              </p>
            </div>
            <div class="panel-body">
              <div class="form-panel2">
                <div class="row">
                  <div class="col-md-12">
                    <p>
                      <strong>
                        <Text id="ils.soa.beneorauthrep" />
                      </strong>
                    </p>
                    <span class="label-container mt-2">
                      <label for="soa_beneficiary_name">
                        <Text id="ils.soa.beneficaryrepsign" />
                        <span class="mandatory-field">*</span>
                      </label>
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        class="form-checkbox2"
                        id="soa_beneficiary_name"
                        name="captureBeneRepSign"
                        checked={
                          props.data.captureBeneRepSign === "YES" ||
                          props.data.beneRepSignDate != ""
                        }
                        onChange={props.handleChange}
                      />
                    </span>
                    <br />
                    <span class="label-container">
                      <label for="soa_beneficiary_representative_signature">
                        <Text id="ils.soa.benerep" />
                        <span class="mandatory-field">*</span>
                      </label>
                      <br />
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="text"
                        class={
                          props.data.beneRepSignature === ""
                            ? "error-input"
                            : "form-control1"
                        }
                        id="soa_beneficiary_representative_signature"
                        name="beneRepSignature"
                        value={props.data.beneRepSignature}
                        maxLength="40"
                        onChange={(event) => {
                          if (
                            event.target.value !== "" &&
                            !DataValidation.test(event.target.value)
                          ) {
                            return;
                          }
                          props.handleChange(event);
                        }}
                      />
                    </span>
                    <span class="label-container">
                      <label for="soa_beneficiary_representative_date">
                        <Text id="ils.soa.benesign" />
                      </label>
                      <br />
                      {props.data.captureBeneRepSign === "YES" ||
                      props.data.beneRepSignDate !== "" ? (
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="text"
                          class="form-control1 width15 readonly"
                          id="soa_beneficiary_representative_date"
                          readonly=""
                          name="beneRepSignDate"
                          maxLength="40"
                          value={
                            props.data.beneRepSignDate != ""
                              ? props.data.beneRepSignDate
                              : (new Date().getMonth() + 1 < 10
                                  ? "0" + (new Date().getMonth() + 1)
                                  : new Date().getMonth() + 1) +
                                "/" +
                                (new Date().getDate() < 10
                                  ? "0" + new Date().getDate()
                                  : new Date().getDate()) +
                                "/" +
                                new Date().getFullYear()
                          }
                          onChange={props.handleChange}
                        />
                      ) : (
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="text"
                          class="form-control1 width15 readonly"
                          id="soa_beneficiary_representative_date"
                          readonly=""
                          name="beneRepSignDate"
                          value=""
                          onChange={props.handleChange}
                          maxLength="40"
                        />
                      )}
                    </span>
                  </div>
                </div>
                <div class="row mt-2">
                  <p className="col-12">
                    <strong>
                      <Text id="ils.soa.authrep" />
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        class={"checkbox-input ml-1"}
                        id="isAuthRep"
                        name="isAuthRep"
                        checked={
                          props?.data?.isAuthRep === "YES" ? true : false
                        }
                        onChange={props.handleChange}
                        value={props?.data?.isAuthRep}
                      />
                    </strong>
                  </p>

                  <span class="col-lg-6 col-sm-12 col-md-12">
                    <label for="soa_representative_name">
                      <Text id="ils.soa.repname" />
                      {props?.data?.isAuthRep === "YES" && "*"}
                    </label>
                    <br />
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="text"
                      class={
                        props.data.repName === "" &&
                        props?.data?.isAuthRep === "YES"
                          ? "error-input"
                          : "form-control1"
                      }
                      id="soa_representative_name"
                      name="repName"
                      value={props.data.repName}
                      maxLength="40"
                      onChange={(event) => {
                        if (
                          event.target.value !== "" &&
                          !DataValidation.test(event.target.value)
                        ) {
                          return;
                        }
                        props.handleChange(event);
                      }}
                    />
                  </span>
                  <span class="col-lg-4 col-sm-12 col-md-12">
                    <label for="soa_your_relationship_to_beneficiary">
                      <Text id="ils.soa.relation" />
                      {props?.data?.isAuthRep === "YES" && "*"}
                    </label>
                    <br />
                    <select
                      disabled={props.data.agentName && !isNew ? true : false}
                      id="relationshipToBene"
                      name="relationshipToBene"
                      class={
                        props.data.relationshipToBene === "" &&
                        props?.data?.isAuthRep === "YES"
                          ? "error-input"
                          : "form-control1"
                      }
                      value={props.data.relationshipToBene}
                      onChange={props.handleChange}
                    >
                      {props.Authrelation.map((item, i) => {
                        return (
                          <option
                            class="select-option"
                            value={item.value}
                            key={i}
                          >
                            {item.label}
                          </option>
                        );
                      })}
                      <option class="select-option" value="SLF">
                        SELF
                      </option>
                    </select>
                  </span>
                </div>

                <div class="row mt-2">
                  <p className="col-12">
                    <strong>
                      <Text id="ils.soa.completedagent" />{" "}
                      <span class="mandatory-field">*</span>
                    </strong>
                  </p>

                  <span class="col-lg-6 col-sm-12 col-md-12">
                    <label for="soa_agent_name">
                      <Text id="ils.soa.agentname" />
                      <span class="mandatory-field">*</span>
                    </label>
                    <br />
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="text"
                      class={
                        props.data.agentName === ""
                          ? "error-input"
                          : "form-control1"
                      }
                      id="soa_agent_name"
                      name="agentName"
                      maxLength="40"
                      value={props.data.agentName}
                      disabled={true}
                      onChange={(event) => {
                        if (
                          event.target.value !== "" &&
                          !DataValidation.test(event.target.value)
                        ) {
                          return;
                        }
                        props.handleChange(event);
                      }}
                    />
                  </span>
                  <span class="col-lg-4 col-sm-12 col-md-12">
                    <label for="soa_agent_phone_number">
                      <Text id="ils.soa.agentphn" />
                      <span class="mandatory-field">*</span>
                    </label>
                    <br />
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="text"
                      class={
                        props.customerId === ILS_CONSTS.ID &&
                        props.data.agentPhone !== ""
                          ? "form-control1"
                          : props.data.agentPhone === "" ||
                            props.data.agentPhone.indexOf("(") === -1 ||
                            props.data.agentPhone.indexOf("(") === -1
                          ? "error-input"
                          : "form-control1"
                      }
                      id="soa_agent_phone_number"
                      name="agentPhone"
                      maxLength="14"
                      value={props.data.agentPhone}
                      onChange={props.handleChange}
                      placeholder="(   )   -"
                    />
                  </span>
                </div>

                <div class="row">
                  <span class="col-lg-6 col-sm-12 col-md-12">
                    <label for="soa_beneficiary_name">
                      <Text id="ils.soa.benename" />
                      <span class="mandatory-field">*</span>
                    </label>
                    <br />
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="text"
                      class={
                        props.data.beneName === ""
                          ? "error-input"
                          : "form-control1"
                      }
                      id="soa_beneficiary_name"
                      name="beneName"
                      value={props.data.beneName}
                      maxLength="40"
                      onChange={(event) => {
                        if (
                          event.target.value !== "" &&
                          !DataValidation.test(event.target.value)
                        ) {
                          return;
                        }
                        props.handleChange(event);
                      }}
                    />
                  </span>
                  <span class="col-lg-4 col-sm-12 col-md-12">
                    <label for="soa_beneficiary_phone_number">
                      <Text id="ils.soa.benephn" />
                      <span class="mandatory-field">*</span>
                    </label>
                    <br />
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="text"
                      class={
                        props.data.benePhone === "" ||
                        props.data.benePhone.indexOf("(") === -1 ||
                        props.data.benePhone.indexOf("(") === -1
                          ? "error-input"
                          : "form-control1"
                      }
                      id="soa_beneficiary_phone_number"
                      name="benePhone"
                      value={props.data.benePhone}
                      onChange={props.handleChange}
                      maxLength="14"
                      placeholder="(   )   -"
                    />
                  </span>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <span class="label-container vw36">
                      <label for="soa_beneficiary_address">
                        <Text id="ils.soa.beneadd" />
                        <span class="mandatory-field">*</span>
                      </label>
                      <br />
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="text"
                        class={
                          props.data.beneAddress === ""
                            ? "error-input"
                            : "form-control1"
                        }
                        id="soa_beneficiary_address"
                        name="beneAddress"
                        value={props.data.beneAddress}
                        maxLength="40"
                        onChange={props.handleChange}
                      />
                    </span>
                  </div>
                  {props.customerId === ILS_CONSTS.ID && (
                    <div class="col-md-6">
                      <span class="label-container vw36">
                        <label htmlFor="soa_medicaidId">
                          <Text id="ils.soa.mid" />
                        </label>
                        <br />
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="text"
                          class={"form-control1"}
                          id="soa_medicaidId"
                          name="medicaidId"
                          value={props.data?.medicaidId}
                          maxLength="10"
                          onChange={props.handleChange}
                        />
                      </span>
                    </div>
                  )}
                  {props.customerId === NEBRASKA_CONSTS.ID && (
                    <div class="col-md-6">
                      <span class="label-container vw36">
                        <label for="beneBirthDate">
                          Beneficiary Date of Birth
                        </label>
                        <br />
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="text"
                          class={"form-control1"}
                          id="beneBirthDate"
                          name="beneBirthDate"
                          value={props.data?.beneBirthDate}
                          maxLength="10"
                          onChange={props.handleDate}
                          placeholder="MM/DD/YYYY"
                          onClick={(e) => props.handleDates("beneBirthDate")}
                        />
                      </span>
                    </div>
                  )}
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <fieldset
                      class="label-container col-md-12"
                      for="soa_initial_method_contact"
                    >
                      <legend>
                        <Text id="ils.soa.initial" />
                        <span class="mandatory-field">*</span>
                      </legend>
                      <label class="mt-2 mb-2 col-sm-12 col-xl-3">
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="radio"
                          id="initial_method_contact1"
                          class="form-radio"
                          name="initialMethodOfContact"
                          value="Sales"
                          checked={
                            props.data.initialMethodOfContact === "Sales"
                              ? true
                              : false
                          }
                          onChange={props.handleChange}
                        />{" "}
                        <Text id="ils.soa.sales" />
                      </label>
                      <label class="col-xl-4 col-sm-12">
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="radio"
                          id="initial_method_contact2"
                          class="form-radio"
                          name="initialMethodOfContact"
                          value="Walk"
                          checked={
                            props.data.initialMethodOfContact === "Walk"
                              ? true
                              : false
                          }
                          onChange={props.handleChange}
                        />{" "}
                        <Text id="ils.soa.walk" />
                      </label>
                      <label class="col-xl-4 col-sm-12">
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="radio"
                          id="initial_method_contact3"
                          class="form-radio"
                          name="initialMethodOfContact"
                          value="Inboun"
                          checked={
                            props.data.initialMethodOfContact === "Inboun"
                              ? true
                              : false
                          }
                          onChange={props.handleChange}
                        />{" "}
                        <Text id="ils.soa.inbound" />
                      </label>
                      <br />
                      <label class="mt-2 mb-2 col-xl-3 col-sm-12">
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="radio"
                          id="initial_method_contact4"
                          class="form-radio"
                          name="initialMethodOfContact"
                          value="Outbou"
                          checked={
                            props.data.initialMethodOfContact === "Outbou"
                              ? true
                              : false
                          }
                          onChange={props.handleChange}
                        />{" "}
                        <Text id="ils.soa.outbound" />
                      </label>
                      <label class="col-xl-4 col-sm-12">
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="radio"
                          id="initial_method_contact5"
                          class="form-radio"
                          name="initialMethodOfContact"
                          value="Permis"
                          checked={
                            props.data.initialMethodOfContact === "Permis"
                              ? true
                              : false
                          }
                          onChange={props.handleChange}
                        />{" "}
                        <Text id="ils.soa.premissioncall" />
                      </label>
                      <span class=" col-xl-5 col-sm-12">
                        <label>
                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            type="radio"
                            id="initial_method_contact6"
                            class="form-radio"
                            name="initialMethodOfContact"
                            value="Other"
                            checked={
                              props.data.initialMethodOfContact === "Other"
                                ? true
                                : false
                            }
                            onChange={props.handleChange}
                          />{" "}
                          <Text id="ils.soa.other" />
                        </label>
                        {props.data.initialMethodOfContact === "Other" && (
                          <span className="pl-1 display-inline-block">
                            <input
                              autoComplete="off"
                              spellcheck="false"
                              aria-autocomplete="both"
                              aria-haspopup="false"
                              type="text"
                              id="salesChannelOth"
                              name="salesChannelOth"
                              value={props.data.salesChannelOth}
                              maxLength="30"
                              onChange={props.handleChange}
                              class={
                                props?.data?.salesChannelOth === ""
                                  ? "error-input"
                                  : "form-control1"
                              }
                            />
                          </span>
                        )}
                      </span>
                    </fieldset>

                    <br />
                    <span class="label-container ">
                      <label for="soa_date_appointment_completed">
                        <Text id="ils.soa.dateapp" />
                        <span class="mandatory-field">*</span>
                      </label>
                      <br />
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        class={
                          props.data.appointmentDateComp === "" ||
                          !moment(
                            props.data.appointmentDateComp,
                            "MM/DD/YYYY",
                            true
                          ).isValid()
                            ? "error-input scrollfix"
                            : "form-control1 scrollfix"
                        }
                        value={props.data.appointmentDateComp}
                        maxLength="10"
                        onChange={props.handleDate}
                        onClick={(e) =>
                          props.handleDates("appointmentDateComp")
                        }
                        name="appointmentDateComp"
                        id="appointmentDateComp"
                        placeholder="MM/DD/YYYY"
                        required=""
                      />
                    </span>
                    <br />
                    <span class="label-container mt-2">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="checkbox"
                        class="form-checkbox3"
                        id="soa_capture_agent_signature"
                        name="CaptureAgentSignature"
                        checked={props.data.CaptureAgentSignature === "YES"}
                        onChange={props.handleChange}
                      />
                      <label for="soa_capture_agent_signature">
                        <Text id="ils.soa.capagent" />
                        <span class="mandatory-field">*</span>
                      </label>
                    </span>
                    <br />
                    {props.customerId === NEBRASKA_CONSTS.ID && (
                      <>
                        <span class="label-container ">
                          <label for="agentSignDate">
                            Date
                            <span class="mandatory-field">*</span>
                          </label>
                          <br />

                          <input
                            autoComplete="off"
                            spellcheck="false"
                            aria-autocomplete="both"
                            aria-haspopup="false"
                            class={
                              props.data?.agentSignDate === "" ||
                              !moment(
                                props.data?.agentSignDate,
                                "MM/DD/YYYY",
                                true
                              ).isValid()
                                ? "error-input scrollfix"
                                : "form-control1 scrollfix"
                            }
                            value={props.data?.agentSignDate}
                            maxLength="10"
                            onChange={props.handleDate}
                            onClick={(e) => props.handleDates("agentSignDate")}
                            name="agentSignDate"
                            id="agentSignDate"
                            placeholder="MM/DD/YYYY"
                            required=""
                          />
                        </span>
                        <br />
                      </>
                    )}
                    <span class="label-container">
                      <label for="soa_agent_signature_print">
                        <Text id="ils.soa.agentsign" />
                        <span class="mandatory-field">*</span>
                      </label>
                      <br />
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="text"
                        class={
                          props.data.agentSign === ""
                            ? "error-input"
                            : "form-control1"
                        }
                        id="soa_agent_signature_print"
                        name="agentSign"
                        value={props.data.agentSign}
                        maxLength="40"
                        onChange={(event) => {
                          if (
                            event.target.value !== "" &&
                            !DataValidation.test(event.target.value)
                          ) {
                            return;
                          }
                          props.handleChange(event);
                        }}
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel mt-3">
              <p>
                <i>
                  <Text id="ils.soa.scope" />
                </i>
              </p>
              {FieldLabel("prospactSOAadvantage", props?.customerId)}
            </div>
          </div>
        )}
      </DialogContent>
      <DialogActions>
        {props.addComment === false &&
          props?.customerId !== VERDA_CONSTS.ID &&
          props?.disable != true && (
            <button
              class="btn btn-dashboard-active noprint"
              onClick={(e) => {
                props.printSoa(e);
              }}
            >
              <Text id="ils.soa.printsoa" />
            </button>
          )}
        {props.okButton && (
          <CustomButtonSecondary
            variant="outlined"
            color="primary"
            onClick={() => {
              props.modalClosed("ok");
            }}
          >
            OK
          </CustomButtonSecondary>
        )}

        {props.addComment ? (
          <button
            class="btn btn-dashboard-active noprint"
            onClick={props.AddCmt}
            disabled={props.data.agentName && !isNew ? true : false}
          >
            {" "}
            <Text id="ils.soa.save" />{" "}
          </button>
        ) : (
          props?.disable != true && (
            <button
              class="btn btn-dashboard-active noprint"
              onClick={props.saveSoa}
              disabled={props.data.agentName && !isNew ? true : false}
            >
              {" "}
              <Text id="ils.soa.save" />{" "}
            </button>
          )
        )}
        {props.cancelButton && (
          <button
            class="btn btn-campaign noprint"
            onClick={() => {
              props.modalClosed("cancel");
            }}
          >
            <Text id="ils.soa.close" />
          </button>
        )}
      </DialogActions>
    </Dialog>
  );
}

const mapStateToProps = (state) => {
  return {
    email: state.login.emailAddress,
    planCardData: state.webApp.planCardData,
    Authrelation: state.campaignProspect.Authrelation,
    lang: state.webApp.language,
  };
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
